import { defineStyleConfig } from '@chakra-ui/styled-system';

const ContainerTheme = defineStyleConfig({
  baseStyle: {
    maxW: 'unset',
  },
  sizes: {},
  variants: {},
  defaultProps: {},
});

export default ContainerTheme;
